export default __webpack_public_path__ + "static/media-and-text-mask-e3fc0d43814c23139386c89f8df97cda.svg";